import React, { useState } from 'react';
import { FORNECEDORES, ARLA, hasPE, fmt, getSaldo, daysAgo, embs, arlaByUnit } from '../constants';

function ModalDetalhe({ d, unit, onClose }) {
  const s = getSaldo(d, unit);
  const dt = new Date(d.data + 'T12:00:00').toLocaleDateString('pt-BR', {
    weekday: 'long', day: '2-digit', month: 'long', year: 'numeric'
  });
  const embList = embs(unit);
  const arlaList = arlaByUnit(unit);

  const Section = ({ title }) => (
    <div style={{ fontSize: 10, fontWeight: 700, color: '#888', textTransform: 'uppercase',
      letterSpacing: '0.08em', margin: '16px 0 8px', fontFamily: '"DM Sans", sans-serif' }}>
      {title}
    </div>
  );

  const Row = ({ label, value, bold }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0',
      borderBottom: '0.5px solid #f0ede8', fontFamily: '"DM Sans", sans-serif' }}>
      <span style={{ fontSize: 12, color: '#555' }}>{label}</span>
      <span style={{ fontSize: 12, color: '#1a1a18', fontWeight: bold ? 600 : 400 }}>{value}</span>
    </div>
  );

  const SubCard = ({ title, cols }) => (
    <div style={{ marginBottom: 8, background: '#f9f8f5', borderRadius: 6, padding: '8px 10px' }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#555', marginBottom: 6, fontFamily: '"DM Sans", sans-serif' }}>{title}</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 4 }}>
        {cols.map(([l, v], i) => (
          <div key={i}>
            <div style={{ fontSize: 10, color: '#aaa', fontFamily: '"DM Sans", sans-serif' }}>{l}</div>
            <div style={{ fontSize: 12, fontWeight: i === 3 ? 600 : 400, color: '#1a1a18', fontFamily: '"DM Sans", sans-serif' }}>{fmt(v)}</div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div style={S.overlay}>
      <div style={S.detalheModal}>
        <div style={S.detalheHeader}>
          <div>
            <div style={{ fontSize: 15, fontWeight: 600, color: '#1a1a18', fontFamily: '"DM Sans", sans-serif' }}>
              Lançamento — {new Date(d.data + 'T12:00:00').toLocaleDateString('pt-BR')}
            </div>
            <div style={{ fontSize: 12, color: '#888', marginTop: 2, fontFamily: '"DM Sans", sans-serif' }}>{dt}</div>
          </div>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>

        <div style={S.detalheBody}>

          {/* Polietileno */}
          {hasPE(unit) && d.pe && (
            <>
              <Section title="Polietileno" />
              <Row label="Saldo inicial" value={`${fmt(d.pe.saldo_ini)} kg`} />
              <Row label="Entradas" value={`${fmt(d.pe.entrada)} kg`} />
              <Row label="Consumo" value={`${fmt(d.pe.consumo)} kg`} />
              <Row label="Saldo final" value={`${fmt(s.peSaldo)} kg`} bold />
            </>
          )}

          {/* Aditivo */}
          {hasPE(unit) && d.aditivo && (d.aditivo.saldo_ini > 0 || d.aditivo.entrada > 0 || d.aditivo.consumo > 0) && (
            <>
              <Section title="Aditivo" />
              <Row label="Saldo inicial" value={`${fmt(d.aditivo.saldo_ini)} L`} />
              <Row label="Entradas" value={`${fmt(d.aditivo.entrada)} L`} />
              <Row label="Consumo" value={`${fmt(d.aditivo.consumo)} L`} />
              <Row label="Saldo final" value={`${fmt((d.aditivo.saldo_ini||0)+(d.aditivo.entrada||0)-(d.aditivo.consumo||0))} L`} bold />
            </>
          )}

          {/* Ureia */}
          <Section title="Ureia por fornecedor" />
          {FORNECEDORES.map(f => {
            const ur = d.ureia?.[f.id];
            if (!ur || (!ur.saldo_ini && !ur.entrada && !ur.consumo)) return null;
            const saldo = (ur.saldo_ini||0)+(ur.entrada||0)-(ur.consumo||0);
            return (
              <SubCard key={f.id} title={f.label}
                cols={[['Saldo ini.', ur.saldo_ini], ['Entrada', ur.entrada], ['Consumo', ur.consumo], ['Saldo', saldo]]} />
            );
          })}
          <Row label="Total ureia" value={`${fmt(s.urSaldo)} kg`} bold />

          {/* Embalagens */}
          <Section title="Embalagens" />
          {embList.map(e => {
            const em = d.emb?.[e.id];
            if (!em) return null;
            const saldo = (em.saldo_ini||0)+(em.entrada||0)-(em.saida||0);
            return (
              <SubCard key={e.id} title={e.label}
                cols={[['Saldo ini.', em.saldo_ini], ['Entrada', em.entrada], ['Saída', em.saida], ['Saldo', saldo]]} />
            );
          })}

          {/* Arla */}
          <Section title="Produção de Arla" />
          {arlaList.map(p => {
            const a = d.arla?.[p.id];
            if (!a || (!a.saldo_ini && !a.producao && !a.saida)) return null;
            const saldo = (a.saldo_ini||0)+(a.producao||0)-(a.saida||0);
            return (
              <SubCard key={p.id} title={`${p.label} (${p.unit})`}
                cols={[['Saldo ini.', a.saldo_ini], ['Produção', a.producao], ['Saída', a.saida], ['Saldo', saldo]]} />
            );
          })}

        </div>

        <div style={S.detalheFooter}>
          <button style={S.btnSecondary} onClick={onClose}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

export default function Historico({ lancamentos, unit, isAdmin, onEdit, onDelete }) {
  const days = [...lancamentos].reverse().slice(0, 30);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [viewing, setViewing] = useState(null);

  const infoMsg = isAdmin
    ? 'Como administrador, você pode corrigir ou excluir qualquer lançamento.'
    : 'Você pode corrigir ou excluir lançamentos dos últimos 2 dias. Registros mais antigos só podem ser alterados pelo administrador.';

  const confirmAndDelete = () => {
    onDelete(confirmDelete);
    setConfirmDelete(null);
  };

  const viewDay = viewing ? days.find(d => d.data === viewing) : null;

  return (
    <div>
      {viewDay && <ModalDetalhe d={viewDay} unit={unit} onClose={() => setViewing(null)} />}

      {confirmDelete && (
        <div style={S.overlay}>
          <div style={S.modal}>
            <div style={S.modalIcon}>!</div>
            <div style={S.modalTitle}>Excluir lançamento?</div>
            <div style={S.modalSub}>
              Você está prestes a excluir o lançamento de{' '}
              <b>{new Date(confirmDelete + 'T12:00:00').toLocaleDateString('pt-BR')}</b>.
              <br />Esta ação não pode ser desfeita.
            </div>
            <div style={S.modalActions}>
              <button style={S.btnSecondary} onClick={() => setConfirmDelete(null)}>Cancelar</button>
              <button style={S.btnDanger} onClick={confirmAndDelete}>Sim, excluir</button>
            </div>
          </div>
        </div>
      )}

      <div style={S.card}>
        <div style={S.cardTitle}>Últimos lançamentos</div>
        <div style={{ ...S.alert, ...S.alertInfo, marginBottom: 12 }}>{infoMsg}</div>

        {!days.length ? (
          <div style={S.empty}>Nenhum registro ainda.</div>
        ) : (
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Data</th>
                <th style={{ ...S.th, textAlign: 'right' }}>Ureia (kg)</th>
                {hasPE(unit) && <th style={{ ...S.th, textAlign: 'right' }}>Polietileno (kg)</th>}
                <th style={{ ...S.th, textAlign: 'right' }}>B20 Arla (un)</th>
                <th style={{ ...S.th, textAlign: 'right' }}>Granel (L)</th>
                <th style={S.th}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {days.map(d => {
                const s = getSaldo(d, unit);
                const dt = new Date(d.data + 'T12:00:00').toLocaleDateString('pt-BR');
                const ago = daysAgo(d.data);
                const agoLabel = ago === 0 ? 'Hoje' : ago === 1 ? 'Ontem' : `${ago} dias atrás`;
                const canAct = isAdmin || ago <= 2;
                return (
                  <tr key={d.data}
                    onMouseEnter={e => e.currentTarget.style.background = '#fafaf8'}
                    onMouseLeave={e => e.currentTarget.style.background = ''}>
                    <td style={{ ...S.td, cursor: 'pointer' }} onClick={() => setViewing(d.data)}>
                      <span style={S.dateMain}>{dt}</span>
                      <span style={S.dateAgo}>{agoLabel}</span>
                    </td>
                    <td style={{ ...S.td, textAlign: 'right', cursor: 'pointer' }} onClick={() => setViewing(d.data)}>{fmt(s.urSaldo)}</td>
                    {hasPE(unit) && <td style={{ ...S.td, textAlign: 'right', cursor: 'pointer' }} onClick={() => setViewing(d.data)}>{fmt(s.peSaldo)}</td>}
                    <td style={{ ...S.td, textAlign: 'right', cursor: 'pointer' }} onClick={() => setViewing(d.data)}>{fmt(s.arla.bomb20)}</td>
                    <td style={{ ...S.td, textAlign: 'right', cursor: 'pointer' }} onClick={() => setViewing(d.data)}>{fmt(s.arla.granel)}</td>
                    <td style={S.td}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button style={S.btnVer} onClick={() => setViewing(d.data)}>Ver</button>
                        {canAct && (
                          <>
                            <button style={S.btnEdit} onClick={() => onEdit(d.data)}>Corrigir</button>
                            <button style={S.btnDelete} onClick={() => setConfirmDelete(d.data)}>Excluir</button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const S = {
  card:      { background: '#fff', border: '0.5px solid #e8e6e0', borderRadius: 10, padding: 16 },
  cardTitle: { fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 12, fontFamily: '"DM Sans", sans-serif' },
  alert:     { padding: '10px 14px', borderRadius: 8, fontSize: 13, fontFamily: '"DM Sans", sans-serif' },
  alertInfo: { background: '#eff6ff', color: '#1d4ed8', border: '0.5px solid #bfdbfe' },
  empty:     { color: '#aaa', fontSize: 13, fontFamily: '"DM Sans", sans-serif' },
  table:     { width: '100%', borderCollapse: 'collapse' },
  th:        { background: '#f5f4f0', padding: '7px 10px', fontSize: 11, fontWeight: 500, color: '#888', borderBottom: '0.5px solid #e8e6e0', fontFamily: '"DM Sans", sans-serif', textAlign: 'left' },
  td:        { padding: '8px 10px', fontSize: 12, borderBottom: '0.5px solid #f0ede8', color: '#1a1a18', fontFamily: '"DM Sans", sans-serif', verticalAlign: 'middle' },
  dateMain:  { fontWeight: 500, marginRight: 6 },
  dateAgo:   { fontSize: 11, color: '#aaa' },
  btnVer:    { background: '#f5f4f0', color: '#555', border: '0.5px solid #e0ddd6', borderRadius: 6, padding: '4px 12px', fontSize: 12, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif', fontWeight: 500 },
  btnEdit:   { background: '#fff', color: '#92400e', border: '0.5px solid #fcd34d', borderRadius: 6, padding: '4px 12px', fontSize: 12, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif', fontWeight: 500 },
  btnDelete: { background: '#fff', color: '#991b1b', border: '0.5px solid #fca5a5', borderRadius: 6, padding: '4px 12px', fontSize: 12, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif', fontWeight: 500 },
  locked:    { fontSize: 11, color: '#ccc', fontFamily: '"DM Sans", sans-serif' },
  overlay:   { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 },
  modal:     { background: '#fff', borderRadius: 12, width: '100%', maxWidth: 380, padding: '28px 28px 24px', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' },
  modalIcon: { width: 44, height: 44, borderRadius: '50%', background: '#fee2e2', color: '#991b1b', fontSize: 22, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', fontFamily: '"DM Sans", sans-serif' },
  modalTitle:    { fontSize: 17, fontWeight: 600, color: '#1a1a18', fontFamily: '"DM Sans", sans-serif', marginBottom: 8 },
  modalSub:      { fontSize: 13, color: '#666', fontFamily: '"DM Sans", sans-serif', lineHeight: 1.6, marginBottom: 20 },
  modalActions:  { display: 'flex', gap: 10, justifyContent: 'center' },
  btnSecondary:  { background: '#fff', color: '#555', border: '0.5px solid #e0ddd6', borderRadius: 7, padding: '9px 20px', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif' },
  btnDanger:     { background: '#dc2626', color: '#fff', border: 'none', borderRadius: 7, padding: '9px 20px', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif' },
  closeBtn:      { background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#aaa', padding: 4 },
  detalheModal:  { background: '#fff', borderRadius: 12, width: '100%', maxWidth: 560, maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' },
  detalheHeader: { padding: '18px 24px', borderBottom: '0.5px solid #e8e6e0', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexShrink: 0 },
  detalheBody:   { padding: '16px 24px', overflowY: 'auto', flex: 1 },
  detalheFooter: { padding: '14px 24px', borderTop: '0.5px solid #e8e6e0', display: 'flex', justifyContent: 'flex-end', flexShrink: 0 },
};
